import {Component, ElementRef, ViewChild, HostListener} from '@angular/core'

import { AppInfo } from '../../models/app-info.model'
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'hub-launcher',
  templateUrl: './hub-launcher.component.html',
  styleUrls: ['./hub-launcher.component.less'],
})
export class HubLauncherComponent {
  @ViewChild('launcher') launcher: ElementRef

  apps: AppInfo[]
  sortByAttr: 'title'
  isActive = false
  hubUrl: string
  currentApp: AppInfo

  constructor(
    private sessionService: SessionService
  ) {
    this.hubUrl = this.sessionService.hubUrl
    this.currentApp = this.sessionService.currentApp
    this.apps = this.sessionService.apps
  }

  openLauncher() {
    this.isActive = true
  }

  @HostListener('document:click', ['$event.target'])
  closeLauncher(target) {
    const hubLauncher = $(target).closest('hub-launcher')

    if (!hubLauncher.length) {
      this.isActive = false
    }
  }
}
